module.exports = "/_next/static/files/ce1952d4c7d62c0a4d675ccadd4b8efe.jpg";